import { Switch } from 'antd';
import { useEffect } from 'react';
import { InfoIcon } from 'src/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getPatientSummaryNotificationSetting } from 'src/modules/SuperAdmin/store/actions/organization.action';

export const PatientSummaryNotificationSetting = ({
  org_uuid,
  notificationSetting,
  setNotificationSetting,
}) => {
  const isMobile = window.innerWidth < 1260;

  const {
    patientSummaryNotificationSetting,
    patientSummaryNotificationSettingLoading,
  } = useSelector((state) => state.organizationState);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPatientSummaryNotificationSetting({ org_uuid }));
  }, [dispatch, org_uuid]);

  useEffect(() => {
    if (!patientSummaryNotificationSettingLoading) {
      setNotificationSetting(patientSummaryNotificationSetting);
    }
  }, [
    patientSummaryNotificationSettingLoading,
    patientSummaryNotificationSetting,
    setNotificationSetting,
  ]);

  return (
    <div className={`${isMobile ? 'mb-24' : ''} bg-white p-4 rounded-2xl mt-4`}>
      <div className="flex items-center">
        <div className="mt-2 ml-1 mr-2 text-lg font-semibold text-[#000]">
          Patient summary notification setting
        </div>
      </div>
      <div className="inline-block">
        <div className="flex items-center bg-[#e6f4ff] rounded-lg border border-[#91caff] pr-2 mt-2">
          <div className="mt-2 ml-2">
            <InfoIcon />
          </div>
          <div className="text-[#000] mt-0.5">
            Send notification to patients when their VCA summary is generated
          </div>
        </div>
      </div>

      <div className="gap-3 flex justify-between mt-3 mr-4">
        <div className="mx-2 text-[#000]">Enable notifications</div>
        <div>
          <Switch
            style={{
              backgroundColor: notificationSetting ? '#00D091' : '#00000040',
            }}
            checked={notificationSetting}
            onChange={(checked) => setNotificationSetting(checked)}
          />
        </div>
      </div>
    </div>
  );
};
